import { Decoder, Encoder } from "@siteimprove/alfa-encoding";
import { URL } from "@siteimprove/alfa-url";
import { Headers } from "./headers.js";
/**
 * {@link https://fetch.spec.whatwg.org/#request-class}
 *
 * @public
 */
export class Request {
    static of(method, url, headers = Headers.empty(), body = new ArrayBuffer(0)) {
        return new Request(method, url, headers, body);
    }
    static _empty = Request.of("GET", URL.blank());
    static empty() {
        return this._empty;
    }
    _method;
    _url;
    _headers;
    _body;
    constructor(method, url, headers, body) {
        this._method = method;
        this._url = url;
        this._headers = headers;
        this._body = body;
    }
    /**
     * {@link https://fetch.spec.whatwg.org/#dom-request-method}
     */
    get method() {
        return this._method;
    }
    /**
     * {@link https://fetch.spec.whatwg.org/#dom-request-url}
     */
    get url() {
        return this._url;
    }
    /**
     * {@link https://fetch.spec.whatwg.org/#dom-request-headers}
     */
    get headers() {
        return this._headers;
    }
    /**
     * {@link https://fetch.spec.whatwg.org/#dom-body-body}
     */
    get body() {
        return this._body;
    }
    toJSON(options) {
        return {
            method: this._method,
            url: this._url.toString(),
            headers: this._headers.toJSON(options),
            body: Decoder.decode(new Uint8Array(this._body)),
        };
    }
    toEARL() {
        return {
            "@context": {
                http: "http://www.w3.org/2011/http#",
            },
            "@type": ["http:Message", "http:Request"],
            "http:methodName": this._method,
            "http:requestURI": this._url.toString(),
            "http:headers": this._headers.toEARL(),
            "http:body": {
                "@context": {
                    cnt: "http://www.w3.org/2011/content#",
                },
                "@type": ["cnt:Content", "cnt:ContentAsText"],
                "cnt:characterEncoding": "utf-8",
                "cnt:chars": Decoder.decode(new Uint8Array(this._body)),
            },
        };
    }
    toString() {
        let request = `${this._method} ${this._url} HTTP/1.1`;
        request += "\n" + this._headers.toString();
        request += "\n";
        request += Decoder.decode(new Uint8Array(this._body));
        return request;
    }
}
/**
 * @public
 */
(function (Request) {
    function from(json) {
        return URL.parse(json.url).map((url) => Request.of(json.method, url, Headers.from(json.headers), Encoder.encode(json.body)));
    }
    Request.from = from;
    function isRequest(value) {
        return value instanceof Request;
    }
    Request.isRequest = isRequest;
})(Request || (Request = {}));
//# sourceMappingURL=request.js.map